import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PASSWORD_REGEX, _clone } from 'src/app/utils/constants';
import { AuthService } from '../../services/auth.service';
import { passwordMatching } from '../../validators/custom.validator';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})

export class ChangePasswordComponent implements OnInit {

  showError: boolean = false;
  changePasswordFrom!: FormGroup;

  isOldPasswordVisible: boolean = false;
  isPasswordVisible: boolean = false;
  isNewPasswordVisible: boolean = false;

  constructor(private _activeModal: NgbActiveModal, private _auth: AuthService,
    private _formBuilder: FormBuilder, private _toastr: ToastrService) { }

  ngOnInit(): void {
    this.changePasswordFrom = this._formBuilder.group({
      oldPassword: [null, Validators.required],
      password: [null, Validators.compose([Validators.required, Validators.maxLength(16), Validators.pattern(PASSWORD_REGEX)])],
      confirmPassword: [null, Validators.compose([Validators.required, Validators.maxLength(16), Validators.pattern(PASSWORD_REGEX)])],
    }, {
      validator: [passwordMatching('password', 'confirmPassword')]
    });
  }

  onChangePassword(): void {
    console.log(this.changePasswordFrom);
    if (this.changePasswordFrom.invalid) {
      this.showValidationMessage();
      return;
    }
    const changePassword = _clone(this.changePasswordFrom.value);
    delete changePassword.confirmPassword;
    this._auth.changePassword(changePassword).then((res: any) => {
      this._toastr.success('Password changed successfully.');
      this.onClose();
    })
  }

  private showValidationMessage(): void {
    const validationMessageDuration = 3000;
    this.showError = true;
    setTimeout(() => this.showError = false, validationMessageDuration);
  }

  onClose(): void {
    this._activeModal.close();
  }
}
